import Typography from "@mui/material/Typography";

import RemoveTopicReportFeedbackModal from "@app/analytics/TopicReport/components/RemoveTopicReportFeedbackModal";
import useTopicReportStore from "@app/analytics/TopicReport/hooks/useTopicReportStore";
import type { TopicError } from "@app/analytics/types";
import LINKS from "@app/common/links";
import ROUTES from "@app/common/routes";

import Button from "@rui/Button";
import { Link } from "@rui/Link";
import ReadLogo from "@rui/ReadLogo";
import Stack from "@rui/Stack";

const TopicReportError = ({
  kind,
}: {
  kind: TopicError["error"] | "unknown";
}) => {
  const showModal = useTopicReportStore(
    (state) => state.showRemoveFeedbackModal
  );

  return (
    <>
      <Stack
        variant="center"
        flex={1}
        spacing={3}
        sx={{ bgcolor: "#FFF", color: "shades.neutral.800" }}
      >
        <ReadLogo />
        <Stack sx={{ maxWidth: "520px", textAlign: "center" }}>
          {kind === "unknown" ? (
            <Stack spacing={0.5}>
              <Typography fontSize="2rem" fontWeight={600}>
                Error
              </Typography>
              <Typography variant="bodyPrimaryReg">
                Something went wrong and your Readout cannot be viewed at this
                time. Please refresh the page or contact{" "}
                <Link href={LINKS.EMAIL.SUPPORT} color="shades.primary.500">
                  support@read.ai
                </Link>{" "}
                if the problem persists.
              </Typography>
            </Stack>
          ) : (
            <Stack spacing={0.5}>
              <Typography fontSize="2rem" fontWeight={600}>
                Report not found
              </Typography>
              <Typography variant="bodyPrimaryReg">
                This Readout does not exist or you do not have access to it.
              </Typography>
            </Stack>
          )}
        </Stack>
        <Button component={Link} to={ROUTES.MEETING_REPORTS}>
          Back to Reports
        </Button>
      </Stack>
      {showModal && <RemoveTopicReportFeedbackModal />}
    </>
  );
};

export default TopicReportError;
